import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

export const ThemeToggle = ({ className = 'text-smoke hover:text-accent' }) => {
  const [dark, setDark] = useState(() => localStorage.getItem('dd-theme') === 'dark');

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem('dd-theme', dark ? 'dark' : 'light');
  }, [dark]);

  return (
    <button
      data-testid="theme-toggle-button"
      onClick={() => setDark(!dark)}
      aria-label="Toggle dark mode"
      className={`p-1.5 transition-colors duration-300 ${className}`}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};
